import { Component } from "react";
import { Redirect } from "react-router-dom";
import t from "prop-types";
import FullScreenLoading from "@app/common/components/FullScreenLoad";

const propTypes = {
  providerLogin: t.func,
  location: t.object,
  isLoading: t.bool,
  currentUser: t.object,
  match: t.object,
};

class LoginWithOauth extends Component {
  constructor(props) {
    super(props);
    const code = new URLSearchParams(props.location.search).get("code");
    const state = new URLSearchParams(props.location.search).get("state");
    if (!props.currentUser.isAuthenticated) {
      this.props.providerLogin(props.match.params.provider, state, code);
    }
  }

  render() {
    if (this.props.isLoading) {
      return <FullScreenLoading />;
    }
    return <Redirect to="/login" />;
  }
}

LoginWithOauth.propTypes = propTypes;

export default LoginWithOauth;
